/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import { getEnvs } from '../utils/env'

const { apiUrl } = getEnvs()

function fromCookie(name) {
  let value = null
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i += 1) {
      const cookie = cookies[i].trim()
      if (cookie.substring(0, name.length + 1) === `${name}=`) {
        value = decodeURIComponent(cookie.substring(name.length + 1))
        break
      }
    }
  }
  console.log(name, ' from cookie=', value)

  return value
}

async function fromAPI(name) {
  const url = `${apiUrl}/csrf-token/`
  let value = null
  try {
    const response = await fetch(`${url}`, {
      method: 'GET',
      credentials: 'include',
    })

    if (response.ok) {
      console.log('response', response)
      const csrfData = await response.json()
      value = csrfData.csrfToken
    } else {
      console.error('error response', response)
      throw new Error('CSRF token request failed ', url)
    }
  } catch (error) {
    console.error('Error on request ', url, ' error ', error)
  }
  console.log(name, ' from API=', value)
  return value
}

export async function getCSRFToken() {
  let value = fromCookie('csrftoken')
  if (value == null) {
    value = await fromAPI('csrftoken')
  }
  return value
}

export function removeCookie(cookieName) {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`
}
